import { Route, Routes } from 'react-router';

import Login from './Login';
import LoginCallback from './LoginCallback';
import LoginDialog from './LoginDialog';

export default function LoginRoutes() {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="/dialog" element={<LoginDialog />} />
      <Route path="/callback" element={<LoginCallback />} />
    </Routes>
  );
}
